export interface ApiTimingReport {
    method: string;
    route: string;
    status: number | null;
    durationMs: number;
    timeout: boolean;
    ok: boolean;
    kind?: 'http' | 'stream';
    firstChunkMs?: number | null;
    messageCount?: number;
    aborted?: boolean;
    errorType?: 'http' | 'exception' | 'abort';
}

type ApiTimingReporter = (report: ApiTimingReport) => void;

let apiTimingReporter: ApiTimingReporter | null = null;

const DUMMY_ORIGIN = 'https://bustly.local';

export const setApiTimingReporter = (reporter: ApiTimingReporter | null) => {
    apiTimingReporter = reporter;
};

export const sanitizeRumRoute = (value?: string, baseURL?: string): string => {
    if (!value) {
        return '';
    }

    try {
        const parsed = new URL(value, baseURL || DUMMY_ORIGIN);
        return templateSensitivePath(parsed.pathname);
    } catch {
        return templateSensitivePath(value.split('?')[0] || '');
    }
};

export const reportApiTiming = (report: ApiTimingReport) => {
    if (!apiTimingReporter) {
        return;
    }

    try {
        apiTimingReporter({
            ...report,
            route: sanitizeRumRoute(report.route),
        });
    } catch {
        // RUM reporting must never affect API behavior.
    }
};

function templateSensitivePath(pathname: string): string {
    return pathname
        .replace(/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/gi, ':id')
        .replace(/\b\d{6,}\b/g, ':id')
        .replace(/\/tasks\/[^/?#]+/gi, '/tasks/:id')
        .replace(/\/requests\/[^/?#]+/gi, '/requests/:id')
        .replace(/\/sessions\/[^/?#]+/gi, '/sessions/:id')
        .replace(/\/workspaces\/[^/?#]+/gi, '/workspaces/:id')
        .replace(/\/users\/[^/?#]+/gi, '/users/:id');
}
